// YENİ TRADRES API - Hızlı ve Güncel Türkiye Adres Verileri
// Backend üzerinden https://tradres.com.tr API'sine erişim

import api from './api';

// Backend API endpoint'leri - Yeni Tradres formatı
const BACKEND_LOCATION_API = '/api/location';

// Şehirleri backend'den çek - YENİ TRADRES API
const fetchCitiesFromBackend = async () => {
  console.log('🏢 Tradres API: Türkiye illeri yükleniyor...');
  try {
    const cities = await api(`${BACKEND_LOCATION_API}/cities`);
    console.log(`✅ Tradres API: ${cities.length} il başarıyla yüklendi`);
    return cities;
  } catch (error) {
    console.error('❌ Tradres API şehirler hatası:', error.message);
    throw error;
  }
};

// İlçeleri backend'den çek - YENİ TRADRES API
const fetchDistrictsFromBackend = async (cityName) => {
  console.log(`🏢 Tradres API: ${cityName} ilçeleri yükleniyor...`);
  try {
    const districts = await api(`${BACKEND_LOCATION_API}/districts/${encodeURIComponent(cityName)}`);
    console.log(`✅ Tradres API: ${cityName} için ${districts.length} ilçe yüklendi`);
    return districts;
  } catch (error) {
    console.error(`❌ Tradres API ${cityName} ilçeleri hatası:`, error.message);
    throw error;
  }
};

// Mahalleleri backend'den çek - YENİ TRADRES API
const fetchNeighborhoodsFromBackend = async (cityName, districtName) => {
  console.log(`🏢 Tradres API: ${cityName}/${districtName} mahalleleri yükleniyor...`);
  try {
    const neighborhoods = await api(`${BACKEND_LOCATION_API}/neighborhoods/${encodeURIComponent(cityName)}/${encodeURIComponent(districtName)}`);
    console.log(`✅ Tradres API: ${cityName}/${districtName} için ${neighborhoods.length} mahalle yüklendi`);
    return neighborhoods;
  } catch (error) {
    console.error(`❌ Tradres API ${cityName}/${districtName} mahalleleri hatası:`, error.message);
    throw error;
  }
};

// Hibrit şehir verisi - önce backend, sonra statik
export const getHybridCities = async (staticFallback) => {
  try {
    // Backend API'yi dene
    const backendData = await fetchCitiesFromBackend();
    return backendData;
  } catch (error) {
    console.log('🔄 Backend API kullanılamıyor, statik veriye geçiliyor');
    try {
      // Statik veriyi kullan
      const staticData = await staticFallback();
      console.log('📋 Statik şehir verisi kullanılıyor');
      return staticData;
    } catch (staticError) {
      console.error('❌ Statik veri de yüklenemedi:', staticError);
      throw new Error('Şehir verileri yüklenemedi');
    }
  }
};

// Hibrit ilçe verisi - önce backend, sonra statik
export const getHybridDistricts = async (cityName, staticFallback, cityId) => {
  try {
    // Backend API'yi dene
    const backendData = await fetchDistrictsFromBackend(cityName);
    return backendData;
  } catch (error) {
    console.log('🔄 Backend API kullanılamıyor, statik veriye geçiliyor');
    try {
      // Statik veriyi kullan
      const staticData = await staticFallback(cityId);
      console.log('📋 Statik ilçe verisi kullanılıyor');
      return staticData;
    } catch (staticError) {
      console.error('❌ Statik veri de yüklenemedi:', staticError);
      throw new Error('İlçe verileri yüklenemedi');
    }
  }
};

// Hibrit mahalle verisi - önce backend, sonra statik
export const getHybridNeighborhoods = async (cityName, districtName, staticFallback, districtId) => {
  try {
    // Backend API'yi dene
    const backendData = await fetchNeighborhoodsFromBackend(cityName, districtName);
    return backendData;
  } catch (error) {
    console.log('🔄 Backend API kullanılamıyor, statik veriye geçiliyor');
    try {
      // Statik veriyi kullan
      const staticData = await staticFallback(districtId);
      console.log('📋 Statik mahalle verisi kullanılıyor');
      return staticData;
    } catch (staticError) {
      console.error('❌ Statik veri de yüklenemedi:', staticError);
      // Mahalle için boş array döndür, zorunlu değil
      return [];
    }
  }
};

export default {
  getHybridCities,
  getHybridDistricts,
  getHybridNeighborhoods
};